/**
 * defa.collections.recpientGroupHolders
 * A Collection of RecipientGroupHolder models.
 * @version 1.0.0
 */
import RecipientGroupHolder from './model-recipientGroup-holder';

const RecipientGroupHolders = Bb.Collection.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	model : RecipientGroupHolder,
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
} );

export default RecipientGroupHolders;